
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/instant",
      function () {
        return require("private-next-pages/instant.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/instant"])
      });
    }
  